/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import _ from "underscore";
import React, { ReactElement } from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";

import PendingAwardsFilterableTableRow from "./pendingAwardsFilterableTableRow";
import { ApprovalRequest } from "../../interfaces/interfaces";

interface PendingAwardsFilterableTableProps {
  claims: ApprovalRequest[];
  handleApprovalRequest: (claim: ApprovalRequest, url: string) => void;
  handleToggleClaim: (claim: ApprovalRequest) => void;
  handleToggleSelectAll: () => void;
  selectAllChecked: boolean;
  selectedFilter: string;
}

const StyledFilterableTable = styled.table`
  tr th {
    padding: 15px 10px;
    font-size: 12px;

    &:nth-child(2) {
      text-align: center;
    }
  }

  tr td {
    max-width: 18vw;

    div {
      min-width: min-content;
    }

    &:first-child {
      padding-left: 30px;
      width: 45px;
      text-align: center;
    }

    &:not(:first-child),
    &:not(:nth-child(2)) {
      width: auto;
    }

    &:nth-child(2) {
      width: 45px;
      text-align: center;
    }

    &:last-child {
      padding-right: 0;
    }
  }

  tr.expandable td.expanded-table div.expanded-row {
    max-height: unset;
  }

  .column-header {
    text-transform: uppercase;
    font-weight: bold;
    width: 33%;
    padding: 15px;
    text-align: left;

    p {
      text-transform: none;
      font-weight: normal;
      padding-top: 5px;
    }
  }

  .dot {
    height: 14px;
    width: 14px;
    background-color: #ffe5a0;
    border-radius: 50%;
    display: inline-block;
  }
`;

export default class PendingAwardsFilterableTable extends React.Component<PendingAwardsFilterableTableProps> {
  render(): ReactElement {
    return (
      <StyledFilterableTable className="fancy-table claims-table">
        <thead className="less-fancy">
          <tr>
            <th />
            <th>
              <input
                checked={this.props.selectAllChecked}
                className="multiselect_all"
                onChange={this.props.handleToggleSelectAll}
                type="checkbox"
              />
            </th>
            <th>{i18n.translate("awards.claimable_awards.date")}</th>
            <th>{i18n.translate("awards.name")}</th>
            <th>{i18n.translate("awards.claimable_awards.recognition")}</th>
            <th>{i18n.translate("awards.claimable_awards.recipients")}</th>
            <th>{i18n.translate("awards.claimable_awards.approve_or_deny")}</th>
            <th>{i18n.translate("awards.claimable_awards.errors")}</th>
          </tr>
        </thead>
        <tbody>
          {this.props.claims.length ? (
            this.props.claims
              .filter(({ claim }) => {
                return (
                  this.props.selectedFilter === claim.awardId ||
                  this.props.selectedFilter === "All"
                );
              })
              .map((claim) => {
                return (
                  <PendingAwardsFilterableTableRow
                    awardClaim={claim}
                    handleToggleClaim={this.props.handleToggleClaim}
                    isLoading={claim.isLoading}
                    key={claim.claim.id}
                    selected={claim.selected || null}
                    selectedFilter={this.props.selectedFilter}
                    handleApprovalRequest={this.props.handleApprovalRequest}
                    levelsValid={claim.claim.levelsValid}
                  />
                );
              })
          ) : (
            <tr>
              <td colSpan={7}>
                {i18n.translate("awards.claimable_awards.no_pending_awards")}
              </td>
            </tr>
          )}
        </tbody>
      </StyledFilterableTable>
    );
  }
}
